import './QrGenerationView.scss';

export { default } from './QrGenerationView';
